<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Finalizar Acompanhamento' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <form class="sample-form validations-form" [formGroup]="validations_form" (ngSubmit)="onSubmit()">
    <div class="gradient-extendido"></div>

    <ion-grid style="margin-top: 30px">
      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-select
              label-placement="stacked"
              interface="action-sheet"
              placeholder="{{'Status' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}"
              okText="{{ 'Confirmar' | translate}}"
              formControlName="idAcompanhamentoStatus"
            >
              <div class="slot-label" slot="label">Status <ion-text color="danger">*</ion-text></div>
              <ion-select-option *ngFor="let status of statusList" [value]="status.id">
                {{status.nome}}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.idAcompanhamentoStatus">
              <div
                class="error-message"
                *ngIf="submitted && validations_form.get('idAcompanhamentoStatus')?.invalid &&
                !validations_form.get('idAcompanhamentoStatus')?.value"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <p class="font-label ion-margin-start">{{'Descrição' | translate}} <ion-text color="danger">*</ion-text></p>
          <ion-item>
            <ion-textarea
              class="custom-style"
              placeholder="{{'Descrição' | translate}}"
              rows="2"
              cols="60"
              formControlName="descricao"
            >
            </ion-textarea>
          </ion-item>
          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.descricao">
              <div
                class="error-message"
                *ngIf="submitted && validations_form.get('descricao')?.invalid"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>

  <ion-row>
    <ion-col size="5">
      <div>
        <ion-button
          class="btn-default"
          expand="block"
          (click)="salvar()"
          style="font-size: 14px !important; margin-top: 30px"
        >
          {{'Finalizar' | translate}}
        </ion-button>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
